// import React, { useEffect, useState, useRef } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import { Spinner } from 'react-bootstrap';
// import axios from 'axios';
// import { BASE_URL } from '../../../services/Api';
// import { authHeader } from '../../../services/auth-header';

// const PumpAraiInternationalSalesQuotationPrint = () => {
//     const { id } = useParams();
//     const navigate = useNavigate();
//     const [isLoading, setIsLoading] = useState(true);
//     const [quotationData, setQuotationData] = useState({});
//     const [exportchargescurrency, setExportchargescurrency] = useState(0);
//     const [rows, setRows] = useState([]);
//     const printRef = useRef();

//     const fetchQuotationData = async () => {
//         try {
//             const response = await axios.get(`${BASE_URL}quotation/findById/${id}`, {
//                 headers: authHeader(),
//             });
//             const data = response.data;
//             setQuotationData(data);
//             setExportchargescurrency(data.exportpreparationchargescurrency || 0);

//             if (data.quotationItems && data.quotationItems.length > 0) {
//                 setRows(data.quotationItems.map(item => ({
//                     description: item.product?.description || '',
//                     productremarks: item.productremarks || "",
//                     quantity: item.quantity,
//                     unitratecurrency: item.unitratecurrency,
//                     totalcurrency: item.totalcurrency,
//                     exchangerate: item.exchangerate,
//                     unitRateInr: item.unitrateinr,
//                     totalInr: item.totalinr,
//                     hsnsacno: item.hsnsacno,
//                     partno: item.partno,
//                     serialnumber: item.serialnumber,
//                     modelnumber: item.modelnumber,
//                     tagnumber: item.tagnumber,
//                     moc: item.moc || item.product?.moc || "",
//                     itemcode: item.itemcode || "",
//                     uom: item.uom,
//                     currency: item.currency || "$ (USD)"
//                 })));
//             }
//         } catch (error) {
//             console.error("Error fetching quotation data", error);
//         } finally {
//             setIsLoading(false);
//         }
//     };

//     useEffect(() => {
//         fetchQuotationData();
//     }, [id]);

//     const handlePrint = () => {
//         const printContent = printRef.current;
//         const WinPrint = window.open('', '', 'width=900,height=650');

//         WinPrint.document.write(`
//             <html>
//                 <head>
//                     <title>International Quotation</title>
//                     <style>
//                         body { 
//                             margin: 0; 
//                             padding: 0; 
//                             font-family: Arial, sans-serif;
//                             background: white;
//                         }
//                         .page {
//                             width: 21cm;
//                             min-height: 29.7cm;
//                             margin: 0 auto 0.5cm auto;
//                             background: white;
//                             box-sizing: border-box;
//                             position: relative;
//                             page-break-after: always;
//                             border: 1px solid black !important;
//                         }
//                         .page:last-child {
//                             page-break-after: auto;
//                         }
//                         @media print {
//                             body { 
//                                 margin: 0; 
//                                 padding: 0;
//                                 -webkit-print-color-adjust: exact;
//                                 color-adjust: exact;
//                             }
//                             .page { 
//                                 margin: 0 auto;
//                                 border: 1px solid black !important;
//                                 box-shadow: none;
//                             }
//                             @page {
//                                 margin: 1cm;
//                                 size: A4;
//                             }
//                         }
//                     </style>
//                 </head>
//                 <body>
//                     ${printContent.innerHTML}
//                 </body>
//             </html>
//         `);
//         WinPrint.document.close();
//         WinPrint.focus();
//         WinPrint.print();
//         WinPrint.close();
//     };

//     const formatDate = (dateString) => {
//         if (!dateString) {
//             return "N/A";
//         } else {
//             const date = new Date(dateString);
//             const day = String(date.getDate()).padStart(2, '0');
//             const month = String(date.getMonth() + 1).padStart(2, '0');
//             const year = date.getFullYear();
//             return `${day}-${month}-${year}`;
//         }
//     };

//     // International specific calculations
//     const netTotalCurrency = rows.reduce((sum, item) => sum + (parseFloat(item.totalcurrency) || 0), 0);
//     const grandTotalCurrency = netTotalCurrency + exportchargescurrency;

//     const numberToWordsWithRupees = (num) => {
//         if (isNaN(num) || num === null || num === undefined) {
//             return "Zero Rupees Only";
//         }

//         const a = [
//             '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine',
//             'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen',
//             'Seventeen', 'Eighteen', 'Nineteen'
//         ];
//         const b = [
//             '', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'
//         ];

//         const inWords = (num) => {
//             if (num < 20) return a[num];
//             if (num < 100) return b[Math.floor(num / 10)] + (num % 10 ? ' ' + a[num % 10] : '');
//             if (num < 1000)
//                 return a[Math.floor(num / 100)] + ' Hundred' + (num % 100 ? ' ' + inWords(num % 100) : '');
//             if (num < 100000)
//                 return inWords(Math.floor(num / 1000)) + ' Thousand' + (num % 1000 ? ' ' + inWords(num % 1000) : '');
//             if (num < 10000000)
//                 return inWords(Math.floor(num / 100000)) + ' Lakh' + (num % 100000 ? ' ' + inWords(num % 100000) : '');
//             return inWords(Math.floor(num / 10000000)) + ' Crore' + (num % 10000000 ? ' ' + inWords(num % 10000000) : '');
//         };

//         const amount = Math.round(Number(num));
//         const words = inWords(amount);
//         return `${words} ${quotationData.quotationcurrency?.replace(/[()]/g, '') || 'USD'} Only`;
//     };

//     const totalInWords = numberToWordsWithRupees(grandTotalCurrency);
//     const getValue = (value, fallback = "N/A") => value || fallback;

//     // Calculate items per page for pagination
//     const itemsPerPage = 10;
//     const actualRows = rows?.length || 0;
//     const totalPages = Math.ceil(actualRows / itemsPerPage);

//     if (isLoading) {
//         return (
//             <div style={{
//                 fontFamily: 'Arial, sans-serif',
//                 textAlign: 'center',
//                 padding: '40px 0'
//             }}>
//                 <Spinner animation="border" variant="primary" />
//                 <p style={{ marginTop: '8px', fontSize: '15px' }}>Loading quotation details...</p>
//             </div>
//         );
//     }

//     // Function to render a single page
//     const renderPage = (pageNumber) => {
//         const startIndex = (pageNumber - 1) * itemsPerPage;
//         const endIndex = Math.min(startIndex + itemsPerPage, actualRows);
//         const currentItems = rows?.slice(startIndex, endIndex) || [];
//         const emptyRowsNeeded = Math.max(0, itemsPerPage - currentItems.length);
//         const isLastPage = pageNumber === totalPages;

//         return (
//             <div key={pageNumber} className="page" style={{
//                 width: '21cm',
//                 minHeight: '29.7cm',
//                 margin: '0 auto 0.5cm auto',
//                 background: 'white',
//                 color: 'black',
//                 fontFamily: 'Arial, sans-serif',
//                 fontSize: '13px',
//                 border: '1px solid black',
//                 boxSizing: 'border-box',
//                 position: 'relative',
//             }}>
//                 {/* Only show header on first page */}
//                 {pageNumber === 1 && (
//                     <div>
//                         {/* Header with Logo on Right Side and Quotation Title */}
//                         <div style={{
//                             textAlign: 'center',
//                             marginBottom: '20px',
//                         }}>
//                             <h1 style={{
//                                 fontSize: '27px',
//                                 fontWeight: 'bold',
//                                 textAlign: 'center',
//                                 marginTop: '20px',
//                             }}>QUOTATION</h1>

//                             {/* Logo on Right Side */}
//                             <div style={{
//                                 position: 'absolute',
//                                 right: '0',
//                                 top: '-30px'
//                             }}>
//                                 <img
//                                     src="/assets/company-logo.png"
//                                     alt="Company Logo"
//                                     style={{
//                                         height: '130px',
//                                         width: '120px',
//                                         display: 'block',
//                                         margin: '3px auto'
//                                     }}
//                                 />
//                             </div>

//                         </div>

//                         {/* To/From Section */}
//                         <table style={{
//                             width: '100%',
//                             borderCollapse: 'collapse',
//                             marginBottom: '0px',
//                             borderTop: '1px solid #000'
//                         }}>
//                             {/* To Section */}
//                             <tr>
//                                 <td style={{
//                                     width: '60%',
//                                     verticalAlign: 'top',
//                                     borderRight: '1px solid #000',
//                                     borderBottom: '1px solid #000',
//                                     padding: '5px'
//                                 }}>
//                                     <div style={{ fontWeight: 'bold', marginBottom: '5px', fontSize: '13px' }}>To :</div>
//                                     <div style={{ marginBottom: '1px', fontSize: '12px' }}>{getValue(quotationData.customer?.companyname)}</div>
//                                     <div style={{ marginBottom: '1px', fontSize: '12px' }}>{getValue(quotationData.customeraddress?.customeraddress)}</div>
//                                     <div style={{ marginBottom: '1px', fontSize: '12px' }}>Mobile No: {getValue(quotationData.contactno)}</div>
//                                     <div style={{ marginBottom: '1px', fontSize: '12px' }}>Kind Attn: {getValue(quotationData.contactperson)}</div>
//                                     <div style={{ fontSize: '12px' }}>{getValue(quotationData.customer?.designation)}</div>
//                                 </td>
//                                 <td style={{
//                                     width: '40%',
//                                     verticalAlign: 'top',
//                                     borderBottom: '1px solid #000',
//                                     padding: '5px'
//                                 }}>
//                                     <div style={{ marginBottom: '3px', fontSize: '12px' }}>
//                                         <strong>Date :</strong> {formatDate(quotationData.quotationdate)}
//                                     </div>
//                                     <div style={{ fontSize: '12px' }}>
//                                         <strong>Ref No :</strong> {getValue(quotationData.quotationno)}
//                                     </div>
//                                     <div style={{ fontSize: '12px' }}>
//                                         <strong>Currency :</strong> {getValue(quotationData.quotationcurrency)}
//                                     </div>
//                                     <div style={{ fontSize: '12px' }}>
//                                         <strong>Exchange Rate :</strong> {getValue(quotationData.quotationexchangerate)}
//                                     </div>
//                                 </td>
//                             </tr>

//                             {/* From Section */}
//                             <tr>
//                                 <td style={{
//                                     width: '60%',
//                                     verticalAlign: 'top',
//                                     borderRight: '1px solid #000',
//                                     padding: '5px'
//                                 }}>
//                                     <div style={{ fontWeight: 'bold', marginBottom: '5px', fontSize: '13px' }}>From :</div>
//                                     <div style={{ marginBottom: '1px', fontSize: '12px', fontWeight: 'bold' }}>Synergy Mechanics Pvt Ltd</div>
//                                     <div style={{ marginBottom: '1px', fontSize: '12px' }}>W96, MIDC Phase II</div>
//                                     <div style={{ marginBottom: '1px', fontSize: '12px' }}>Dombivli – 421203</div>
//                                     <div style={{ marginBottom: '1px', fontSize: '12px' }}>Dist: Thane, Mumbai</div>
//                                     <div style={{ marginBottom: '1px', fontSize: '12px' }}>India</div>
//                                     <div style={{ marginBottom: '1px', fontSize: '12px' }}>{getValue(quotationData.contactperson)}</div>
//                                     <div style={{ fontSize: '12px' }}>{getValue(quotationData.contactno)}</div>
//                                 </td>
//                                 <td style={{
//                                     width: '40%',
//                                     verticalAlign: 'top',
//                                     padding: '5px'
//                                 }}>
//                                     <div style={{ marginBottom: '3px', fontSize: '12px' }}>
//                                         <strong>Serial No :</strong> {getValue(rows?.[0]?.serialnumber)}
//                                     </div>
//                                     <div style={{ marginBottom: '3px', fontSize: '12px' }}>
//                                         <strong>Model No :</strong> {getValue(rows?.[0]?.modelnumber)}
//                                     </div>
//                                     <div style={{ fontSize: '12px' }}>
//                                         <strong>Tag No :</strong> {getValue(rows?.[0]?.tagnumber)}
//                                     </div>
//                                 </td>
//                             </tr>
//                         </table>
//                     </div>
//                 )}

//                 {/* Table for current page */}
//                 <div>
//                     <table style={{
//                         width: '100%',
//                         borderCollapse: 'collapse',
//                         marginBottom: '12px',
//                         border: '1px solid #000'
//                     }}>
//                         <thead>
//                             <tr>
//                                 <th style={{
//                                     border: '1px solid #000',
//                                     textAlign: 'center',
//                                     fontWeight: '700',
//                                     fontSize: '13px',
//                                     backgroundColor: '#f8f9fa',
//                                     width: '5%',
//                                     padding: '5px'
//                                 }}>Sr. No.</th>
//                                 <th style={{
//                                     border: '1px solid #000',
//                                     textAlign: 'center',
//                                     fontWeight: '700',
//                                     fontSize: '13px',
//                                     backgroundColor: '#f8f9fa',
//                                     width: '45%',
//                                     padding: '5px'
//                                 }}>Item Description</th>
//                                 <th style={{
//                                     border: '1px solid #000',
//                                     textAlign: 'center',
//                                     fontWeight: '700',
//                                     fontSize: '13px',
//                                     backgroundColor: '#f8f9fa',
//                                     width: '15%',
//                                     padding: '5px'
//                                 }}>Part No.</th>
//                                 <th style={{
//                                     border: '1px solid #000',
//                                     textAlign: 'center',
//                                     fontWeight: '700',
//                                     fontSize: '13px',
//                                     backgroundColor: '#f8f9fa',
//                                     width: '10%',
//                                     padding: '5px'
//                                 }}>Qty</th>
//                                 <th style={{
//                                     border: '1px solid #000',
//                                     textAlign: 'center',
//                                     fontWeight: '700',
//                                     fontSize: '13px',
//                                     backgroundColor: '#f8f9fa',
//                                     width: '10%',
//                                     padding: '5px'
//                                 }}>UOM</th>
//                                 <th style={{
//                                     border: '1px solid #000',
//                                     textAlign: 'center',
//                                     fontWeight: '700',
//                                     fontSize: '13px',
//                                     backgroundColor: '#f8f9fa',
//                                     width: '15%',
//                                     padding: '5px'
//                                 }}>Unit Price ({quotationData.quotationcurrency})</th>
//                                 <th style={{
//                                     border: '1px solid #000',
//                                     textAlign: 'center',
//                                     fontWeight: '700',
//                                     fontSize: '13px',
//                                     backgroundColor: '#f8f9fa',
//                                     width: '15%',
//                                     padding: '5px'
//                                 }}>Total ({quotationData.quotationcurrency})</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {currentItems.map((item, index) => (
//                                 <tr key={startIndex + index}>
//                                     <td style={{
//                                         border: '1px solid #000',
//                                         padding: '5px',
//                                         textAlign: 'center',
//                                         verticalAlign: 'top',
//                                         fontSize: '12px'
//                                     }}>{startIndex + index + 1}</td>
//                                     <td style={{
//                                         border: '1px solid #000',
//                                         padding: '5px',
//                                         textAlign: 'left',
//                                         verticalAlign: 'top',
//                                         fontSize: '12px'
//                                     }}>
//                                         <div style={{
//                                             fontSize: '12px',
//                                             fontWeight: '600',
//                                             textAlign: 'left',
//                                             marginBottom: '3px'
//                                         }}>{getValue(item?.description)}</div>
//                                         <div style={{
//                                             fontSize: '11px',
//                                             textAlign: 'left',
//                                             fontStyle: 'italic',
//                                             color: '#666',
//                                             marginBottom: '3px'
//                                         }}>{getValue(item?.productremarks)}</div>
//                                     </td>
//                                     <td style={{
//                                         border: '1px solid #000',
//                                         padding: '5px',
//                                         textAlign: 'center',
//                                         verticalAlign: 'top',
//                                         fontSize: '12px'
//                                     }}>{getValue(item?.partno)}</td>
//                                     <td style={{
//                                         border: '1px solid #000',
//                                         padding: '5px',
//                                         textAlign: 'center',
//                                         verticalAlign: 'top',
//                                         fontSize: '12px'
//                                     }}>{getValue(item?.quantity)}</td>
//                                     <td style={{
//                                         border: '1px solid #000',
//                                         padding: '5px',
//                                         textAlign: 'center',
//                                         verticalAlign: 'top',
//                                         fontSize: '12px'
//                                     }}>{getValue(item?.uom)}</td>
//                                     <td style={{
//                                         border: '1px solid #000',
//                                         padding: '5px',
//                                         textAlign: 'right',
//                                         verticalAlign: 'top',
//                                         fontSize: '12px'
//                                     }}>{getValue(item?.unitratecurrency)?.toLocaleString('en-US', { minimumFractionDigits: 2 })}</td>
//                                     <td style={{
//                                         border: '1px solid #000',
//                                         padding: '5px',
//                                         textAlign: 'right',
//                                         verticalAlign: 'top',
//                                         fontSize: '12px'
//                                     }}>{getValue(item?.totalcurrency)?.toLocaleString('en-US', { minimumFractionDigits: 2 })}</td>
//                                 </tr>
//                             ))}

//                             {/* Empty Rows */}
//                             {Array.from({ length: emptyRowsNeeded }).map((_, index) => (
//                                 <tr key={`empty-${index}`}>
//                                     <td style={{ border: '1px solid #000', padding: '5px', textAlign: 'center' }}>&nbsp;</td>
//                                     <td style={{ border: '1px solid #000', padding: '5px', textAlign: 'left' }}>&nbsp;</td>
//                                     <td style={{ border: '1px solid #000', padding: '5px', textAlign: 'center' }}>&nbsp;</td>
//                                     <td style={{ border: '1px solid #000', padding: '5px', textAlign: 'center' }}>&nbsp;</td>
//                                     <td style={{ border: '1px solid #000', padding: '5px', textAlign: 'center' }}>&nbsp;</td>
//                                     <td style={{ border: '1px solid #000', padding: '5px', textAlign: 'right' }}>&nbsp;</td>
//                                     <td style={{ border: '1px solid #000', padding: '5px', textAlign: 'right' }}>&nbsp;</td>
//                                 </tr>
//                             ))}

//                             {/* Total Row - Only on last page */}
//                             {isLastPage && (
//                                 <>
//                                     <tr>
//                                         <td colSpan="6" style={{
//                                             border: '1px solid #000',
//                                             padding: '10px',
//                                             textAlign: 'right',
//                                             fontWeight: '700',
//                                             fontSize: '13px'
//                                         }}>Net Total</td>
//                                         <td style={{
//                                             border: '1px solid #000',
//                                             padding: '10px',
//                                             textAlign: 'right',
//                                             fontWeight: '700',
//                                             fontSize: '13px'
//                                         }}>{netTotalCurrency?.toLocaleString('en-US', { minimumFractionDigits: 2 })}</td>
//                                     </tr>
//                                     <tr>
//                                         <td colSpan="6" style={{
//                                             border: '1px solid #000',
//                                             padding: '8px',
//                                             textAlign: 'right',
//                                             fontWeight: '700',
//                                             fontSize: '13px'
//                                         }}>Export Preparation Charge and DAP India Charge</td>
//                                         <td style={{
//                                             border: '1px solid #000',
//                                             padding: '8px',
//                                             textAlign: 'right',
//                                             fontWeight: '700',
//                                             fontSize: '13px'
//                                         }}>{exportchargescurrency?.toLocaleString('en-US', { minimumFractionDigits: 2 })}</td>
//                                     </tr>
//                                     <tr>
//                                         <td colSpan="6" style={{
//                                             border: '1px solid #000',
//                                             padding: '10px',
//                                             textAlign: 'right',
//                                             fontWeight: '700',
//                                             fontSize: '14px',
//                                             backgroundColor: '#f0f0f0'
//                                         }}>Grand Total</td>
//                                         <td style={{
//                                             border: '1px solid #000',
//                                             padding: '10px',
//                                             textAlign: 'right',
//                                             fontWeight: '700',
//                                             fontSize: '14px',
//                                             backgroundColor: '#f0f0f0'
//                                         }}>{grandTotalCurrency?.toLocaleString('en-US', { minimumFractionDigits: 2 })}</td>
//                                     </tr>
//                                     <tr>
//                                         <td colSpan={7} style={{
//                                             border: '1px solid #000',
//                                             padding: '8px',
//                                             textAlign: 'left',
//                                             fontWeight: '700',
//                                             fontSize: '13px'
//                                         }}>
//                                             In Words: {totalInWords}
//                                         </td>
//                                     </tr>
//                                 </>
//                             )}
//                         </tbody>
//                     </table>
//                 </div>

//                 {/* Footer - Only on last page */}
//                 {isLastPage && (
//                     <div style={{ marginTop: '0px' }}>
//                         <div style={{
//                             display: 'flex',
//                             justifyContent: 'space-between',
//                             alignItems: 'flex-start'
//                         }}>
//                             <div style={{ flex: '1', paddingRight: '20px', paddingLeft: '5px' }}>
//                                 <div style={{ marginBottom: '0px' }}>
//                                     <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '8px' }}>
//                                         <div style={{ minWidth: '140px', fontWeight: '600', fontSize: '13px' }}>Make</div>
//                                         <span style={{ margin: '0 6px', fontWeight: '600' }}>:</span>
//                                         <div style={{ fontSize: '13px', lineHeight: '1.3' }}>Arai Pump Mfg.Co.,Ltd.</div>
//                                     </div>
//                                     <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '8px' }}>
//                                         <div style={{ minWidth: '140px', fontWeight: '600', fontSize: '13px' }}>Delivery</div>
//                                         <span style={{ margin: '0 6px', fontWeight: '600' }}>:</span>
//                                         <div style={{ fontSize: '13px', lineHeight: '1.3' }}>13 Weeks after PO</div>
//                                     </div>
//                                     <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '8px' }}>
//                                         <div style={{ minWidth: '140px', fontWeight: '600', fontSize: '13px' }}>Payment</div>
//                                         <span style={{ margin: '0 6px', fontWeight: '600' }}>:</span>
//                                         <div style={{ fontSize: '13px', lineHeight: '1.3' }}>50% with PO balance against readiness of material</div>
//                                     </div>
//                                     <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '8px' }}>
//                                         <div style={{ minWidth: '140px', fontWeight: '600', fontSize: '13px' }}>Validity</div>
//                                         <span style={{ margin: '0 6px', fontWeight: '600' }}>:</span>
//                                         <div style={{ fontSize: '13px', lineHeight: '1.3' }}>30 Days</div>
//                                     </div>
//                                     <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '8px' }}>
//                                         <div style={{ minWidth: '140px', fontWeight: '600', fontSize: '13px' }}>Prices</div>
//                                         <span style={{ margin: '0 6px', fontWeight: '600' }}>:</span>
//                                         <div style={{ fontSize: '13px', lineHeight: '1.3' }}>FOB, Mumbai India</div>
//                                     </div>
//                                     <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '8px' }}>
//                                         <div style={{ minWidth: '140px', fontWeight: '600', fontSize: '13px' }}>GW</div>
//                                         <span style={{ margin: '0 6px', fontWeight: '600' }}>:</span>
//                                         <div style={{ fontSize: '13px', lineHeight: '1.3' }}>1.5 kg</div>
//                                     </div>
//                                 </div>
//                             </div>
//                             <div style={{ flex: '0 0 200px', borderLeft: '1px solid #000', paddingLeft: '5px' }}>
//                                 <div style={{ marginBottom: '5px', fontSize: '13px' }}>For,</div>
//                                 <div style={{ padding: '0px 0px 75px 0px', fontWeight: '700', fontStyle: 'italic', fontSize: '15px' }}>Synergy Mechanics Pvt Ltd</div>
//                                 <div style={{ fontSize: '13px', fontWeight: '600', textAlign: 'center' }}>Authorised Signatory</div>
//                             </div>
//                         </div>

//                         {/* Signature Section */}
//                         <div style={{ marginTop: '5px', textAlign: 'left', borderTop: '1px solid #ccc', paddingTop: '5px', paddingLeft: '5px' }}>
//                             <p style={{ margin: '5px 0', fontSize: '12px' }}>Best Regards,</p>
//                             <p style={{ margin: '5px 0', fontWeight: 'bold', fontSize: '12px' }}>{getValue(quotationData.contactperson)}</p>
//                             <p style={{ margin: '5px 0', fontSize: '12px' }}>Synergy Mechanics Pvt Ltd</p>
//                             <p style={{ margin: '5px 0', fontSize: '12px' }}>M: {getValue(quotationData.contactno)}</p>
//                         </div>
//                     </div>
//                 )}

//                 {/* Page number */}
//                 <div style={{
//                     position: 'absolute',
//                     bottom: '12px',
//                     right: '25px',
//                     fontSize: '11px',
//                     color: '#666'
//                 }}>
//                     Page {pageNumber} of {totalPages}
//                 </div>
//             </div>
//         );
//     };

//     return (
//         <>
//             <style>
//                 {`
//                     @media print {
//                         body * {
//                             visibility: hidden;
//                         }
//                         .print-section, .print-section * {
//                             visibility: visible;
//                         }
//                         .print-section {
//                             position: absolute;
//                             left: 0;
//                             top: 0;
//                             width: 100%;
//                             padding: 0;
//                             margin: 0;
//                         }
//                         .no-print {
//                             display: none !important;
//                         }
//                         .page {
//                             page-break-after: always;
//                             border: 1px solid black !important;
//                             margin: 0 auto !important;
//                         }
//                         .page:last-child {
//                             page-break-after: auto;
//                         }
//                         @page {
//                             margin: 1cm;
//                             size: A4;
//                         }
//                     }
//                 `}
//             </style>

//             <div className="no-print" style={{
//                 display: 'flex',
//                 gap: '10px',
//                 justifyContent: 'center',
//                 marginBottom: '16px',
//                 padding: '12px'
//             }}>
//                 <button className="btn btn-secondary" onClick={() => navigate(-1)} style={{ fontSize: '13px', padding: '8px 16px' }}>
//                     ← Back
//                 </button>
//                 <button className="btn btn-primary" onClick={handlePrint} style={{ fontSize: '13px', padding: '8px 16px' }}>
//                     🖨️ Print Quotation
//                 </button>
//             </div>

//             <div ref={printRef} className="print-section">
//                 {Array.from({ length: totalPages }, (_, i) => renderPage(i + 1))}
//             </div>
//         </>
//     );
// };

// export default PumpAraiInternationalSalesQuotationPrint;





import React, { useEffect, useState, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import axios from 'axios';
import { BASE_URL } from '../../../services/Api';
import { authHeader } from '../../../services/auth-header';

const PumpAraiInternationalSalesQuotationPrint = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [quotationData, setQuotationData] = useState({});
    const [exportchargescurrency, setExportchargescurrency] = useState(0);
    const [rows, setRows] = useState([]);
    const printRef = useRef();

    const fetchQuotationData = async () => {
        try {
            const response = await axios.get(`${BASE_URL}quotation/findById/${id}`, {
                headers: authHeader(),
            });
            const data = response.data;
            setQuotationData(data);
            setExportchargescurrency(data.exportpreparationchargescurrency || 0);

            if (data.quotationItems && data.quotationItems.length > 0) {
                setRows(data.quotationItems.map(item => ({
                    description: item.product?.description || '',
                    productremarks: item.productremarks || "",
                    quantity: item.quantity,
                    unitratecurrency: item.unitratecurrency,
                    totalcurrency: item.totalcurrency,
                    exchangerate: item.exchangerate,
                    unitRateInr: item.unitrateinr,
                    totalInr: item.totalinr,
                    hsnsacno: item.hsnsacno,
                    partno: item.partno,
                    serialnumber: item.serialnumber,
                    modelnumber: item.modelnumber,
                    tagnumber: item.tagnumber,
                    moc: item.moc || item.product?.moc || "",
                    itemcode: item.itemcode || "",
                    uom: item.uom,
                    currency: item.currency || "$ (USD)"
                })));
            }
        } catch (error) {
            console.error("Error fetching quotation data", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchQuotationData();
    }, [id]);

    // const handlePrint = () => {
    //     const printContent = printRef.current;
    //     const WinPrint = window.open('', '', 'width=900,height=650');

    //     WinPrint.document.write(`
    //         <html>
    //             <head>
    //                 <title>International Quotation</title>
    //                 <style>
    //                     * {
    //                         box-sizing: border-box;
    //                     }
    //                     body { 
    //                         margin: 0 !important; 
    //                         padding: 0 !important; 
    //                         font-family: Arial, sans-serif;
    //                         background: white;
    //                         width: 21cm;
    //                     }
    //                     .page-container {
    //                         width: 21cm !important;
    //                         max-width: 21cm !important;
    //                         margin: 0 auto !important;
    //                         background: white;
    //                         position: relative;
    //                     }
    //                     .page {
    //                         width: 21cm !important;
    //                         max-width: 21cm !important;
    //                         min-height: 29.7cm;
    //                         margin: 0 auto !important;
    //                         background: white;
    //                         position: relative;
    //                         page-break-after: always;
    //                         border: 1px solid black !important;
    //                         overflow: hidden;
    //                     }
    //                     .page-content {
    //                         padding: 0.2cm;
    //                         width: 100%;
    //                         height: 100%;
    //                     }
    //                     .page:last-child {
    //                         page-break-after: auto;
    //                     }
    //                     @media print {
    //                         body { 
    //                             margin: 0 !important; 
    //                             padding: 0 !important;
    //                             -webkit-print-color-adjust: exact;
    //                             color-adjust: exact;
    //                             width: 21cm !important;
    //                         }
    //                         .page-container {
    //                             margin: 0 !important;
    //                             padding: 0 !important;
    //                             width: 21cm !important;
    //                         }
    //                         .page { 
    //                             margin: 0 auto !important;
    //                             border: 1px solid black !important;
    //                             box-shadow: none;
    //                             width: 21cm !important;
    //                         }
    //                         @page {
    //                             margin: 1cm !important;
    //                             size: A4 portrait;
    //                         }
    //                     }
    //                 </style>
    //             </head>
    //             <body>
    //                 <div class="page-container">
    //                     ${printContent.innerHTML}
    //                 </div>
    //             </body>
    //         </html>
    //     `);
    //     WinPrint.document.close();
    //     WinPrint.focus();
    //     setTimeout(() => {
    //         WinPrint.print();
    //         WinPrint.close();
    //     }, 500);
    // };



    const handlePrint = () => {
        const printContent = printRef.current;
        const WinPrint = window.open('', '', 'width=900,height=650');

        WinPrint.document.write(`
            <html>
                <head>
                    <title>Purchase Order</title>
                    <style>
                        body { 
                            margin: 0; 
                            padding: 0; 
                            font-family: Arial, sans-serif;
                            background: white;
                        }
                        .page {
                            width: 21cm;
                            min-height: 29.7cm;
                            margin: 0 auto 0.5cm auto;
                            background: white;
                            box-sizing: border-box;
                            position: relative;
                            page-break-after: always;
                            border: 1px solid black !important;
                        }
                        .page:last-child {
                            page-break-after: auto;
                        }
                        @media print {
                            body { 
                                margin: 0; 
                                padding: 0;
                                -webkit-print-color-adjust: exact;
                                color-adjust: exact;
                            }
                            .page { 
                                margin: 0 auto;
                                border: 1px solid black !important;
                                box-shadow: none;
                            }
                            @page {
                                margin: 1cm;
                                size: A4;
                            }
                        }
                    </style>
                </head>
                <body>
                    ${printContent.innerHTML}
                </body>
            </html>
        `);
        WinPrint.document.close();
        WinPrint.focus();
        WinPrint.print();
        WinPrint.close();
    };
    const formatDate = (dateString) => {
        if (!dateString) {
            return "N/A";
        } else {
            const date = new Date(dateString);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            return `${day}-${month}-${year}`;
        }
    };

    // International specific calculations
    const netTotalCurrency = rows.reduce((sum, item) => sum + (parseFloat(item.totalcurrency) || 0), 0);
    const grandTotalCurrency = netTotalCurrency + exportchargescurrency;

    const numberToWordsWithRupees = (num) => {
        if (isNaN(num) || num === null || num === undefined) {
            return "Zero Rupees Only";
        }

        const a = [
            '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine',
            'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen',
            'Seventeen', 'Eighteen', 'Nineteen'
        ];
        const b = [
            '', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'
        ];

        const inWords = (num) => {
            if (num < 20) return a[num];
            if (num < 100) return b[Math.floor(num / 10)] + (num % 10 ? ' ' + a[num % 10] : '');
            if (num < 1000)
                return a[Math.floor(num / 100)] + ' Hundred' + (num % 100 ? ' ' + inWords(num % 100) : '');
            if (num < 100000)
                return inWords(Math.floor(num / 1000)) + ' Thousand' + (num % 1000 ? ' ' + inWords(num % 1000) : '');
            if (num < 10000000)
                return inWords(Math.floor(num / 100000)) + ' Lakh' + (num % 100000 ? ' ' + inWords(num % 100000) : '');
            return inWords(Math.floor(num / 10000000)) + ' Crore' + (num % 10000000 ? ' ' + inWords(num % 10000000) : '');
        };

        const amount = Math.round(Number(num));
        const words = inWords(amount);
        return `${words} ${quotationData.quotationcurrency?.replace(/[()]/g, '') || 'USD'} Only`;
    };

    const totalInWords = numberToWordsWithRupees(grandTotalCurrency);
    const getValue = (value, fallback = "N/A") => value || fallback;

    // Calculate items per page for pagination
    const itemsPerPage = 5;
    const actualRows = rows?.length || 0;
    const totalPages = Math.ceil(actualRows / itemsPerPage);

    if (isLoading) {
        return (
            <div style={{
                fontFamily: 'Arial, sans-serif',
                textAlign: 'center',
                padding: '40px 0'
            }}>
                <Spinner animation="border" variant="primary" />
                <p style={{ marginTop: '8px', fontSize: '15px' }}>Loading quotation details...</p>
            </div>
        );
    }

    // Function to render a single page
    const renderPage = (pageNumber) => {
        const startIndex = (pageNumber - 1) * itemsPerPage;
        const endIndex = Math.min(startIndex + itemsPerPage, actualRows);
        const currentItems = rows?.slice(startIndex, endIndex) || [];
        const emptyRowsNeeded = Math.max(0, itemsPerPage - currentItems.length);
        const isLastPage = pageNumber === totalPages;

        return (
            <div key={pageNumber} className="page" style={{
                width: '21cm',
                maxWidth: '21cm',
                minHeight: '29.7cm',
                margin: '0 auto 0.5cm auto',
                background: 'white',
                color: 'black',
                fontFamily: 'Arial, sans-serif',
                border: '1px solid black',
                position: 'relative',
                overflow: 'hidden'
            }}>
                <div className="page-content" style={{ padding: '0.2cm' }}>
                    {/* Only show header on first page */}
                    {pageNumber === 1 && (
                        <div style={{ width: '100%' }}>
                            {/* Header with Logo on Right Side and Quotation Title */}
                            <div style={{
                                textAlign: 'center',
                                marginBottom: '20px',
                                position: 'relative',
                                width: '100%'
                            }}>
                                <h1 style={{
                                    fontSize: '27px',
                                    fontWeight: 'bold',
                                    textAlign: 'center',
                                    marginTop: '10px',
                                    marginBottom: '15px',
                                    width: '100%'
                                }}>QUOTATION</h1>

                                {/* Logo on Right Side */}
                                <div style={{
                                    position: 'absolute',
                                    right: '0',
                                    top: '-46px'
                                }}>
                                    <img
                                        src="/assets/company-logo.png"
                                        alt="Company Logo"
                                        style={{
                                            height: '130px',
                                            width: '120px',
                                            display: 'block'
                                        }}
                                    />
                                </div>
                            </div>

                            {/* To/From Section */}
                            <table style={{
                                width: '100%',
                                borderCollapse: 'collapse',
                                marginBottom: '15px',
                                border: '1px solid #000',
                                tableLayout: 'fixed'
                            }}>
                                <tbody>
                                    {/* To Section */}
                                    <tr>
                                        <td style={{
                                            width: '60%',
                                            verticalAlign: 'top',
                                            borderRight: '1px solid #000',
                                            borderBottom: '1px solid #000',
                                            padding: '8px',
                                            overflowWrap: 'break-word'
                                        }}>
                                            <div style={{ fontWeight: 'bold', marginBottom: '5px', fontSize: '13px' }}>To :</div>
                                            <div style={{ marginBottom: '3px', fontSize: '12px' }}>{getValue(quotationData.customer?.companyname)}</div>
                                            <div style={{ marginBottom: '3px', fontSize: '12px' }}>{getValue(quotationData.customeraddress?.customeraddress)}</div>
                                            <div style={{ marginBottom: '3px', fontSize: '12px' }}>Mobile No: {getValue(quotationData.contactno)}</div>
                                            <div style={{ marginBottom: '3px', fontSize: '12px' }}>Kind Attn: {getValue(quotationData.contactperson)}</div>
                                            <div style={{ fontSize: '12px' }}>{getValue(quotationData.customer?.designation)}</div>
                                        </td>
                                        <td style={{
                                            width: '40%',
                                            verticalAlign: 'top',
                                            borderBottom: '1px solid #000',
                                            padding: '8px',
                                            overflowWrap: 'break-word'
                                        }}>
                                            <div style={{ marginBottom: '3px', fontSize: '12px' }}>
                                                <strong>Date :</strong> {formatDate(quotationData.quotationdate)}
                                            </div>
                                            <div style={{ fontSize: '12px' }}>
                                                <strong>Ref No :</strong> {getValue(quotationData.quotationno)}
                                            </div>
                                            <div style={{ fontSize: '12px' }}>
                                                <strong>Currency :</strong> {getValue(quotationData.quotationcurrency)}
                                            </div>
                                            <div style={{ fontSize: '12px' }}>
                                                <strong>Exchange Rate :</strong> {getValue(quotationData.quotationexchangerate)}
                                            </div>
                                        </td>
                                    </tr>

                                    {/* From Section */}
                                    <tr>
                                        <td style={{
                                            width: '60%',
                                            verticalAlign: 'top',
                                            borderRight: '1px solid #000',
                                            padding: '8px',
                                            overflowWrap: 'break-word'
                                        }}>
                                            <div style={{ fontWeight: 'bold', marginBottom: '5px', fontSize: '13px' }}>From :</div>
                                            <div style={{ marginBottom: '3px', fontSize: '12px', fontWeight: 'bold' }}>Synergy Mechanics Pvt Ltd</div>
                                            <div style={{ marginBottom: '3px', fontSize: '12px' }}>W96, MIDC Phase II</div>
                                            <div style={{ marginBottom: '3px', fontSize: '12px' }}>Dombivli – 421203</div>
                                            <div style={{ marginBottom: '3px', fontSize: '12px' }}>Dist: Thane, Mumbai</div>
                                            <div style={{ marginBottom: '3px', fontSize: '12px' }}>India</div>
                                            <div style={{ marginBottom: '3px', fontSize: '12px' }}>{getValue(quotationData.contactperson)}</div>
                                            <div style={{ fontSize: '12px' }}>{getValue(quotationData.contactno)}</div>
                                        </td>
                                        <td style={{
                                            width: '40%',
                                            verticalAlign: 'top',
                                            padding: '8px',
                                            overflowWrap: 'break-word'
                                        }}>
                                            <div style={{ marginBottom: '3px', fontSize: '12px' }}>
                                                <strong>Serial No :</strong> {getValue(rows?.[0]?.serialnumber)}
                                            </div>
                                            <div style={{ marginBottom: '3px', fontSize: '12px' }}>
                                                <strong>Model No :</strong> {getValue(rows?.[0]?.modelnumber)}
                                            </div>
                                            <div style={{ fontSize: '12px' }}>
                                                <strong>Tag No :</strong> {getValue(rows?.[0]?.tagnumber)}
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    )}

                    {/* Table for current page */}
                    <div style={{ width: '100%', overflow: 'hidden' }}>
                        <table style={{
                            width: '100%',
                            borderCollapse: 'collapse',
                            marginBottom: '12px',
                            border: '1px solid #000',
                            tableLayout: 'fixed',
                            fontSize: '12px'
                        }}>
                            <thead>
                                <tr>
                                    <th style={{
                                        border: '1px solid #000',
                                        textAlign: 'center',
                                        fontWeight: '700',
                                        backgroundColor: '#f8f9fa',
                                        width: '5%',
                                        padding: '5px 3px',
                                        overflowWrap: 'break-word'
                                    }}>Sr. No.</th>
                                    <th style={{
                                        border: '1px solid #000',
                                        textAlign: 'center',
                                        fontWeight: '700',
                                        backgroundColor: '#f8f9fa',
                                        width: '45%',
                                        padding: '5px 3px',
                                        overflowWrap: 'break-word'
                                    }}>Item Description</th>
                                    <th style={{
                                        border: '1px solid #000',
                                        textAlign: 'center',
                                        fontWeight: '700',
                                        backgroundColor: '#f8f9fa',
                                        width: '15%',
                                        padding: '5px 3px',
                                        overflowWrap: 'break-word'
                                    }}>Part No.</th>
                                    <th style={{
                                        border: '1px solid #000',
                                        textAlign: 'center',
                                        fontWeight: '700',
                                        backgroundColor: '#f8f9fa',
                                        width: '10%',
                                        padding: '5px 3px',
                                        overflowWrap: 'break-word'
                                    }}>Qty</th>
                                    <th style={{
                                        border: '1px solid #000',
                                        textAlign: 'center',
                                        fontWeight: '700',
                                        backgroundColor: '#f8f9fa',
                                        width: '10%',
                                        padding: '5px 3px',
                                        overflowWrap: 'break-word'
                                    }}>UOM</th>
                                    <th style={{
                                        border: '1px solid #000',
                                        textAlign: 'center',
                                        fontWeight: '700',
                                        backgroundColor: '#f8f9fa',
                                        width: '15%',
                                        padding: '5px 3px',
                                        overflowWrap: 'break-word'
                                    }}>Unit Price ({quotationData.quotationcurrency})</th>
                                    <th style={{
                                        border: '1px solid #000',
                                        textAlign: 'center',
                                        fontWeight: '700',
                                        backgroundColor: '#f8f9fa',
                                        width: '15%',
                                        padding: '5px 3px',
                                        overflowWrap: 'break-word'
                                    }}>Total ({quotationData.quotationcurrency})</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentItems.map((item, index) => (
                                    <tr key={startIndex + index}>
                                        <td style={{
                                            border: '1px solid #000',
                                            padding: '5px 3px',
                                            textAlign: 'center',
                                            verticalAlign: 'top',
                                            overflowWrap: 'break-word'
                                        }}>{startIndex + index + 1}</td>
                                        <td style={{
                                            border: '1px solid #000',
                                            padding: '5px 3px',
                                            textAlign: 'left',
                                            verticalAlign: 'top',
                                            overflowWrap: 'break-word'
                                        }}>
                                            <div style={{
                                                fontWeight: '600',
                                                textAlign: 'left',
                                                marginBottom: '3px',
                                                wordBreak: 'break-word'
                                            }}>{getValue(item?.description)}</div>
                                            <div style={{
                                                textAlign: 'left',
                                                fontStyle: 'italic',
                                                color: '#666',
                                                marginBottom: '3px',
                                                wordBreak: 'break-word',
                                                fontSize: '11px'
                                            }}>{getValue(item?.productremarks)}</div>
                                        </td>
                                        <td style={{
                                            border: '1px solid #000',
                                            padding: '5px 3px',
                                            textAlign: 'center',
                                            verticalAlign: 'top',
                                            overflowWrap: 'break-word'
                                        }}>{getValue(item?.partno)}</td>
                                        <td style={{
                                            border: '1px solid #000',
                                            padding: '5px 3px',
                                            textAlign: 'center',
                                            verticalAlign: 'top',
                                            overflowWrap: 'break-word'
                                        }}>{getValue(item?.quantity)}</td>
                                        <td style={{
                                            border: '1px solid #000',
                                            padding: '5px 3px',
                                            textAlign: 'center',
                                            verticalAlign: 'top',
                                            overflowWrap: 'break-word'
                                        }}>{getValue(item?.uom)}</td>
                                        <td style={{
                                            border: '1px solid #000',
                                            padding: '5px 3px',
                                            textAlign: 'right',
                                            verticalAlign: 'top',
                                            overflowWrap: 'break-word'
                                        }}>{getValue(item?.unitratecurrency)?.toLocaleString('en-US', { minimumFractionDigits: 2 })}</td>
                                        <td style={{
                                            border: '1px solid #000',
                                            padding: '5px 3px',
                                            textAlign: 'right',
                                            verticalAlign: 'top',
                                            overflowWrap: 'break-word'
                                        }}>{getValue(item?.totalcurrency)?.toLocaleString('en-US', { minimumFractionDigits: 2 })}</td>
                                    </tr>
                                ))}

                                {/* Empty Rows */}
                                {Array.from({ length: emptyRowsNeeded }).map((_, index) => (
                                    <tr key={`empty-${index}`}>
                                        <td style={{ border: '1px solid #000', padding: '5px 3px', textAlign: 'center' }}>&nbsp;</td>
                                        <td style={{ border: '1px solid #000', padding: '5px 3px', textAlign: 'left' }}>&nbsp;</td>
                                        <td style={{ border: '1px solid #000', padding: '5px 3px', textAlign: 'center' }}>&nbsp;</td>
                                        <td style={{ border: '1px solid #000', padding: '5px 3px', textAlign: 'center' }}>&nbsp;</td>
                                        <td style={{ border: '1px solid #000', padding: '5px 3px', textAlign: 'center' }}>&nbsp;</td>
                                        <td style={{ border: '1px solid #000', padding: '5px 3px', textAlign: 'right' }}>&nbsp;</td>
                                        <td style={{ border: '1px solid #000', padding: '5px 3px', textAlign: 'right' }}>&nbsp;</td>
                                    </tr>
                                ))}

                                {/* Total Row - Only on last page */}
                                {isLastPage && (
                                    <>
                                        <tr>
                                            <td colSpan="6" style={{
                                                border: '1px solid #000',
                                                padding: '8px 5px',
                                                textAlign: 'right',
                                                fontWeight: '700'
                                            }}>Net Total</td>
                                            <td style={{
                                                border: '1px solid #000',
                                                padding: '8px 5px',
                                                textAlign: 'right',
                                                fontWeight: '700'
                                            }}>{netTotalCurrency?.toLocaleString('en-US', { minimumFractionDigits: 2 })}</td>
                                        </tr>
                                        <tr>
                                            <td colSpan="6" style={{
                                                border: '1px solid #000',
                                                padding: '8px 5px',
                                                textAlign: 'right',
                                                fontWeight: '700'
                                            }}>Export Preparation Charge and DAP India Charge</td>
                                            <td style={{
                                                border: '1px solid #000',
                                                padding: '8px 5px',
                                                textAlign: 'right',
                                                fontWeight: '700'
                                            }}>{exportchargescurrency?.toLocaleString('en-US', { minimumFractionDigits: 2 })}</td>
                                        </tr>
                                        <tr>
                                            <td colSpan="6" style={{
                                                border: '1px solid #000',
                                                padding: '8px 5px',
                                                textAlign: 'right',
                                                fontWeight: '700',
                                                backgroundColor: '#f0f0f0',
                                                fontSize: '13px'
                                            }}>Grand Total</td>
                                            <td style={{
                                                border: '1px solid #000',
                                                padding: '8px 5px',
                                                textAlign: 'right',
                                                fontWeight: '700',
                                                backgroundColor: '#f0f0f0',
                                                fontSize: '13px'
                                            }}>{grandTotalCurrency?.toLocaleString('en-US', { minimumFractionDigits: 2 })}</td>
                                        </tr>
                                        <tr>
                                            <td colSpan={7} style={{
                                                border: '1px solid #000',
                                                padding: '8px 5px',
                                                textAlign: 'left',
                                                fontWeight: '700',
                                                wordBreak: 'break-word'
                                            }}>
                                                In Words: {totalInWords}
                                            </td>
                                        </tr>
                                    </>
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* Footer - Only on last page */}
                    {isLastPage && (
                        <div style={{ marginTop: '10px', width: '100%' }}>
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'flex-start',
                                width: '100%'
                            }}>
                                <div style={{ flex: '1', paddingRight: '15px' }}>
                                    <div style={{ marginBottom: '10px' }}>
                                        <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '8px' }}>
                                            <div style={{ minWidth: '140px', fontWeight: '600', fontSize: '12px' }}>Make</div>
                                            <span style={{ margin: '0 6px', fontWeight: '600' }}>:</span>
                                            <div style={{ fontSize: '12px', lineHeight: '1.3' }}>Arai Pump Mfg.Co.,Ltd.</div>
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '8px' }}>
                                            <div style={{ minWidth: '140px', fontWeight: '600', fontSize: '12px' }}>Delivery</div>
                                            <span style={{ margin: '0 6px', fontWeight: '600' }}>:</span>
                                            <div style={{ fontSize: '12px', lineHeight: '1.3' }}>13 Weeks after PO</div>
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '8px' }}>
                                            <div style={{ minWidth: '140px', fontWeight: '600', fontSize: '12px' }}>Payment</div>
                                            <span style={{ margin: '0 6px', fontWeight: '600' }}>:</span>
                                            <div style={{ fontSize: '12px', lineHeight: '1.3' }}>50% with PO balance against readiness of material</div>
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '8px' }}>
                                            <div style={{ minWidth: '140px', fontWeight: '600', fontSize: '12px' }}>Validity</div>
                                            <span style={{ margin: '0 6px', fontWeight: '600' }}>:</span>
                                            <div style={{ fontSize: '12px', lineHeight: '1.3' }}>30 Days</div>
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '8px' }}>
                                            <div style={{ minWidth: '140px', fontWeight: '600', fontSize: '12px' }}>Prices</div>
                                            <span style={{ margin: '0 6px', fontWeight: '600' }}>:</span>
                                            <div style={{ fontSize: '12px', lineHeight: '1.3' }}>FOB, Mumbai India</div>
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '8px' }}>
                                            <div style={{ minWidth: '140px', fontWeight: '600', fontSize: '12px' }}>GW</div>
                                            <span style={{ margin: '0 6px', fontWeight: '600' }}>:</span>
                                            <div style={{ fontSize: '12px', lineHeight: '1.3' }}>1.5 kg</div>
                                        </div>
                                    </div>
                                </div>
                                <div style={{ flex: '0 0 200px', borderLeft: '1px solid #000', paddingLeft: '10px' }}>
                                    <div style={{ marginBottom: '5px', fontSize: '12px' }}>For,</div>
                                    <div style={{ padding: '0px 0px 75px 0px', fontWeight: '700', fontStyle: 'italic', fontSize: '14px' }}>Synergy Mechanics Pvt Ltd</div>
                                    <div style={{ fontSize: '12px', fontWeight: '600', textAlign: 'center' }}>Authorised Signatory</div>
                                </div>
                            </div>

                            {/* Signature Section */}
                            <div style={{ marginTop: '15px', textAlign: 'left', borderTop: '1px solid #ccc', paddingTop: '10px', width: '100%' }}>
                                <p style={{ margin: '5px 0', fontSize: '12px' }}>Best Regards,</p>
                                <p style={{ margin: '5px 0', fontWeight: 'bold', fontSize: '12px' }}>{getValue(quotationData.contactperson)}</p>
                                <p style={{ margin: '5px 0', fontSize: '12px' }}>Synergy Mechanics Pvt Ltd</p>
                                <p style={{ margin: '5px 0', fontSize: '12px' }}>M: {getValue(quotationData.contactno)}</p>
                            </div>
                        </div>
                    )}

                    {/* Page number */}
                    <div style={{
                        position: 'absolute',
                        bottom: '12px',
                        right: '25px',
                        fontSize: '11px',
                        color: '#666'
                    }}>
                        Page {pageNumber} of {totalPages}
                    </div>
                </div>
            </div>
        );
    };

    return (
        <>
            <style>
                {`
                    @media print {
                        body * {
                            visibility: hidden;
                        }
                        .print-section, .print-section * {
                            visibility: visible;
                        }
                        .print-section {
                            position: absolute;
                            left: 0;
                            top: 0;
                            width: 21cm !important;
                            max-width: 21cm !important;
                            margin: 0 auto !important;
                            padding: 0 !important;
                        }
                        .no-print {
                            display: none !important;
                        }
                        .page {
                            page-break-after: always;
                            border: 1px solid black !important;
                            margin: 0 auto !important;
                            width: 21cm !important;
                        }
                        .page:last-child {
                            page-break-after: auto;
                        }
                        @page {
                            margin: 1cm !important;
                            size: A4 portrait;
                        }
                    }
                `}
            </style>

            <div className="no-print" style={{
                display: 'flex',
                gap: '10px',
                justifyContent: 'center',
                marginBottom: '16px',
                padding: '12px'
            }}>
                <button className="btn btn-secondary" onClick={() => navigate(-1)} style={{ fontSize: '13px', padding: '8px 16px' }}>
                    ← Back
                </button>
                <button className="btn btn-primary" onClick={handlePrint} style={{ fontSize: '13px', padding: '8px 16px' }}>
                    🖨️ Print Quotation
                </button>
            </div>

            <div ref={printRef} className="print-section" style={{
                width: '21cm',
                maxWidth: '21cm',
                margin: '0 auto',
                border: '1px solid #ccc'
            }}>
                {Array.from({ length: totalPages }, (_, i) => renderPage(i + 1))}
            </div>
        </>
    );
};

export default PumpAraiInternationalSalesQuotationPrint;